export const businessBenefits = [
  {
    title: 'Appointments bookings',
    description:
      'Stay in control of your calendar, schedule training sessions, and rebook or cancel sessions from Pata scheduling software.',
  },
  {
    title: 'Client communications',
    description: 'Reduce no-shows and save time with automated reminders and client updates.',
  },
  {
    title: 'Services and locations for your dog training business',
    description: 'Manage your catalogue of services and where they take place in one intuitive platform.',
  },
  {
    title: 'Staff, shifts and schedule management',
    description:
      'Add unlimited team members then easily organise shifts, time off and services without the admin headache.',
  },
];
